import { formatPrice } from 'shared/lib/formatting';

import type { BidTiersModel } from '../../@x';

import styles from './BidTiers.module.scss';

interface BidTiersContentProps {
  className?: string;
  serviceName: string;
  bidTiers: BidTiersModel;
}

export function BidTiersContent({ className, serviceName, bidTiers }: BidTiersContentProps) {
  return (
    <div className={className}>
      <div className="mb-3 flex items-center justify-between gap-4 text-[10px] font-medium uppercase text-slate-600">
        <span>{serviceName}</span>
        <span>BID</span>
      </div>
      <div className="flex flex-col gap-2">
        {bidTiers.map((bid) => (
          <div
            key={bid.bid}
            className="flex items-center justify-between gap-1 text-[12px] text-slate-900"
          >
            <span className="pr-2">{bid.label}</span>
            <span className={`${styles.line} -mb-2 flex-1`} />
            <span className="pl-2 font-medium">{formatPrice(bid.bid)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
